import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import NewCircuitLocationForm from './wireline-location-form.component';
import NewCircuitSubscriptionForm from './wireline-subscription-form.component';
import NewCircuitBusinessForm from './wireline-business-form.component';
import { newCircuitSubscriptionActions } from "./../../../../../../../store/external/request-reducer/order-request-reducer/wireline-request/new-circuit/new-circuit-subscription.reducer";
import { createRequestActions } from "./../../../../../../../store/external/request-reducer/create-request.reducer";
import { fileAttachmentActions } from "./../../../../../../../store/external/common-reducer/file-attachment.reducer";
import { requestDetailsActions } from "./../../../../../../../store/external/request-reducer/request-details.reducer";
import Translation from '../../../../../../common/translation/translation.component';
import { TRANSLATIONS as translation } from '../../../../../../../utils/constant.utils';
import { Milestone } from '../../../../../../common/milestone/milestone.component';

class NewCircuitFormExhibitA extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLocationForm: true,
            isSubscriptionForm: false,
            isBusinessForm: false,
            activeIndex:0,
            milestones:[
                "location",
                "capital_pos",
                "business_justification"
            ],
        }
    }

    componentWillUnmount() {
        const { updateOrderRequest } = this.props;

        this.props.resetNewCircuitForm();
        this.props.resetRequestData();
        this.props.resetFileAttachment();
        this.props.onSetFirstLoad(true);
        updateOrderRequest(false);
    }

    nextAction = () => {

        const { isLocationForm, isSubscriptionForm } = this.state;
        const { disableROBCheckbox } = this.props;

        if (isSubscriptionForm) {
            this.setState({
                isLocationForm: false,
                isSubscriptionForm: false,
                isBusinessForm: true,
                activeIndex: 2  
            });
        }
        else if (isLocationForm) {
            this.setState({
                isLocationForm: false,
                isSubscriptionForm: true,
                isBusinessForm: false,
                activeIndex: 1   
            });

            disableROBCheckbox(true);
        }
        else {
            console.log("Submit")
        }
    }

    prevAction = () => {

        const { isSubscriptionForm, isBusinessForm } = this.state;
        const { disableROBCheckbox } = this.props;

        if (isBusinessForm) {
            this.setState({
                isLocationForm: false,
                isSubscriptionForm: true,
                isBusinessForm: false,
                activeIndex: 1
            });
        }
        else if (isSubscriptionForm) {
            this.setState({
                isLocationForm: true,
                isSubscriptionForm: false,
                isBusinessForm: false,
                activeIndex: 0
            });

            disableROBCheckbox(false);
        }

    }

    displayForm = () => {
        const { isLocationForm, isSubscriptionForm } = this.state;
        let form;

        if (isLocationForm) {
            form = <NewCircuitLocationForm isUpdate={this.props.wirelineLocationFormA.isAmending} onClickCancel={this.onClickCancel} nextAction={this.nextAction} />
        } else if (isSubscriptionForm) {
            form = <NewCircuitSubscriptionForm onClickCancel={this.onClickCancel} nextAction={this.nextAction} prevAction={this.prevAction}/>
        } else {
            form = <NewCircuitBusinessForm isUpdate={this.props.wirelineLocationFormA.isAmending} hideRequestModal={this.props.hideRequestModal} onClickCancel={this.onClickCancel} prevAction={this.prevAction} modalMessage={this.props.modalMessage}/>
        }

        return (form);
    }

    onClickCancel = () => {
        const { modalClose } = this.props;

        if (modalClose !== null && modalClose !== undefined) {
            modalClose();
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    render() {
        return (
            <div>
                <Row>
                    <Col xs={12} md={12} lg={12}>
                        <h6 className="plan-detail-sub-header"><Translation translationKey="order_request_details" /></h6>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12}>
                        <Milestone milestones={this.state.milestones} activeIndex={this.state.activeIndex}/>
                    </Col>
                </Row>
                {this.displayForm()}
            </div>
        );
    }
};
export default connect(
    state => {
        const { createRequest, translation } = state;
        const { wirelineLocationFormA } = state.form;
        return {
            createRequest
            , wirelineLocationFormA
            , ...translation
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, newCircuitSubscriptionActions
                , createRequestActions
                , fileAttachmentActions
                , requestDetailsActions
            ),
            dispatch
        )
)(NewCircuitFormExhibitA);